import {CreateStakeholderRelationship, FindStakeholdersByAddress, FindStakeholdersByName} from "Api/public/axios";

const PREFETCH_STAKEHOLDER_PAYLOAD = "wdyk/prefetchStakeholdersPayload";
const STAKEHOLDERS_LIMIT = 15

export default class StakeholderService {
  constructor(store, router, eventsBus) {
    this.store = store;
    this.router = router;
    this.eventsBus = eventsBus;
  }

  async findByAddress(address) {
    try {
      this.clearStakeholderErrors();
      const response = await FindStakeholdersByAddress.get("", {
        params: address
      });
      this.store.dispatch("wdyk/addressStakeholders", response.data);
      this.store.dispatch(PREFETCH_STAKEHOLDER_PAYLOAD, address);
    } catch (error) {
      this.handleStakeholderErrors("An error occurred when searching for influencers. Please check your information and try again.");
      console.log("Error searching stakeholders by address.", error);
    }
  }

  async findByName(term, offset = 0, limit = STAKEHOLDERS_LIMIT) {
    if (!term || term.length === 0) {
      this.clearSearch();
      return;
    }
    try {
      const response = await FindStakeholdersByName.get('', {
        params: {
          term,
          offset: offset,
          limit: limit
        }
      });
      this.eventsBus.$emit("searchStakeholders", response.data)
      this.eventsBus.$emit("clearRelationshipForm")

      this.store.dispatch("wdyk/searchStakeholders", response.data);
      this.store.dispatch("wdyk/searchTerm", term);
      return response.data
    } catch(error) {
      this.store.dispatch("wdyk/searchStakeholders", []);
      this.handleStakeholderErrors("An error occurred. Please try again");
      console.log("Error searching stakeholders by name.", error);
    }
  }

  async createRelationship(id, rating, hdyk, details, willingToCall) {
    willingToCall = willingToCall === true || willingToCall === "true" ? true : false;
    try {
      await CreateStakeholderRelationship.post('', {
        id,
        rating,
        hdyk,
        details,
        willingToCall
      });
      this.store.dispatch("wdyk/addRelationship", id);
      this.eventsBus.$emit('clearRelationshipForm');
    } catch(error) {
      this.handleStakeholderErrors("Uh oh, an error occurred. Unable to submit relationship. Please try again.");
      console.log("Error submitting relationship", error);
    }
  }

  handleStakeholderErrors(message) {
    this.store.dispatch("wdyk/stakeholderError", true);
    this.eventsBus.$emit("stakeholderError", message);
    return
  }

  clearStakeholderErrors() {
    this.store.dispatch("wdyk/stakeholderError", false);
    this.eventsBus.$emit("stakeholderError", '');
  }

  clearSearch() {
    this.clearStakeholderErrors();
    this.eventsBus.$emit("searchStakeholders", 0)
    this.store.dispatch("wdyk/searchTerm", null);
    this.eventsBus.$emit("clearSearch");
    this.store.dispatch("wdyk/clearSearchStakeholders");
  }
}
